import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Brand } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/how-it-works", label: "How it works", testid: "nav-how" },
  { to: "/pricing", label: "Pricing", testid: "nav-pricing" },
  { to: "/integrations", label: "Integrations", testid: "nav-integrations" },
  { to: "/blog", label: "Blog", testid: "nav-blog" },
];

export function SiteHeader() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-40 bg-cream/80 backdrop-blur-md border-b border-warmborder/60">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Brand />
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-espresso-soft">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={n.testid}
              className={`transition-colors hover:text-olive ${pathname === n.to ? "text-olive" : ""}`}>
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <Link to="/dashboard"><Button size="sm" className="rounded-full px-5" data-testid="nav-dashboard">Dashboard</Button></Link>
          ) : (
            <>
              <Link to="/login"><Button variant="ghost" size="sm" data-testid="nav-login">Log in</Button></Link>
              <Link to="/signup"><Button size="sm" className="rounded-full px-5" data-testid="nav-start">Start tracking</Button></Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
